<div
	class="modal fade"
	id="filtersModal"
	tabindex="-1"
	role="dialog"
	aria-labelledby="filtersModalLabel"
	aria-hidden="true"
>
	<div class="modal-dialog modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-body">
				<div class="container">
					<div class="mb-3">
						<label for="createdBy" class="mt-3">Sprzedane przez</label>
						<ng-select
							id="createdBy"
							name="createdBy"
							[(ngModel)]="filters.createdBy"
							[multiple]="false"
							[closeOnSelect]="false"
						>
							<ng-option *ngFor="let item of users" [value]="item.id">{{ item.name }}</ng-option>
						</ng-select>
					</div>
					<div class="mb-3">
						<div class="row g-2">
							<div class="form-floating col-md">
								<input
									type="date"
									class="form-control"
									name="dateFrom"
									[(ngModel)]="filters.dateFrom"
									id="dateFrom"
								/>
								<label for="dateFrom" class="form-label">Data sprzedaży od</label>
							</div>
							<div class="form-floating col-md">
								<input
									type="date"
									class="form-control"
									name="dateTo"
									[(ngModel)]="filters.dateTo"
									id="dateTo"
								/>
								<label for="dateTo" class="form-label">Data sprzedaży do</label>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<div class="container">
					<div class="row">
						<div class="col-sm-7 text-start">
							<button type="button" class="btn btn-danger me-1" (click)="filtersClear()">Wyczyść</button>
							<button type="button" class="btn btn-success" (click)="filtersDefault()">Domyślne</button>
						</div>
						<div class="col-sm-5 text-end">
							<button type="button" class="btn btn-primary me-1" (click)="filtersSave()">Pokaż</button>
							<button
								type="button"
								class="btn btn-secondary"
								(click)="filtersClose()"
								data-bs-dismiss="modal"
							>
								Anuluj
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
